export const SET_PRICING_POOL_DATA = 'SET_PRICING_POOL_DATA';
export const setPricingPoolData = (data) => ({
    type: SET_PRICING_POOL_DATA,
    payload: data
});
